import axios from './axios-instance';

const API_URL = '/_exclusive/neo';

export const fetchNeoToggles = toggleIds => {
  const requestPayload = { id: toggleIds, platform: 'bl_app_pwa_mitra_android' };
  return axios.$post(`${API_URL}/toggles`, requestPayload);
};

export const fetchNeoConfigs = configKeys => {
  const requestPayload = { id: configKeys };
  return axios.$post(`${API_URL}/configs`, requestPayload);
};
